import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

type ButtonColor = 'white';

@Component({
  selector: 'snap-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
})
export class IconButtonComponent {
  @Input() icon: string;
  @Input() loading = false;
  @Input() color: ButtonColor = 'white';
  @Output() clicked = new EventEmitter<MouseEvent>();

  protected handleClick(event: MouseEvent): void {
    this.clicked.emit(event);
  }
}
